import { Button } from "./ui/button";
import { Phone, Mail, MapPin } from "lucide-react";
import logoImage from '../assets/logo.png';

export function Header() {
  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      {/* Top contact bar */}
      <div className="bg-fun-teal text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
            <div className="flex items-center gap-2">
              <Phone className="h-4 w-4" />
              <span>(702) 397-8894</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              <span>fun_n_sun@mvdsl.com</span>
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4" />
              <span>Overton, Nevada</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src={logoImage} 
              alt="Fun 'n Sun Mobile Home & RV Park Logo" 
              className="h-16 w-auto"
            />
          </div>

          <nav className="hidden md:flex items-center gap-6">
            <a href="#home" className="text-fun-navy hover:text-primary transition-colors font-medium">Home</a>
            <a href="#amenities" className="text-fun-navy hover:text-primary transition-colors font-medium">Amenities</a>
            <a href="#rates" className="text-fun-navy hover:text-primary transition-colors font-medium">Rates</a>
            <a href="#attractions" className="text-fun-navy hover:text-primary transition-colors font-medium">Attractions</a>
            <a href="#faq" className="text-fun-navy hover:text-primary transition-colors font-medium">FAQ</a>
            <a href="#contact" className="text-fun-navy hover:text-primary transition-colors font-medium">Contact</a>
          </nav>

          <Button className="hidden md:block bg-primary hover:bg-primary/90">
            Make Reservation
          </Button>
        </div>
      </div>
    </header>
  );
}